module.exports = __webpack_public_path__ + "img/meetone.e2f8bff6.svg";